import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import { deleteLocalStorageData } from '../utils/index.js'
import { PIPELINE_TEST_SITE_ID, isRfmAvailable } from '@/components/instruments/pipeline/testSite'

import i18n from '../languages/index.js'

const Authorization = () => import('@/components/main/Authorization')

const Desktop = () => import('@/components/desktop/Desktop')

const Leads = () => import('@/components/leads/Leads')
const AllLeads = () => import('@/components/leads/AllLeads')
const Lead = () => import('@/components/leads/lead/Lead')
const Multilead = () => import('@/components/leads/multilead/Multilead')

const AllSegments = () => import('@/components/leads/AllSegments')
const SegmentEditing = () => import('@/components/leads/segment/SegmentEditing')
const SegmentStatistic = () => import('@/components/leads/segment/Statistic')
const SegmentAssortment = () => import('@/components/leads/segment/Assortment')
const SegmentCart = () => import('@/components/leads/segment/Cart')
const SegmentLetters = () => import('@/components/leads/segment/Letters')
const SegmentForms = () => import('@/components/leads/segment/Forms')
const SegmentLeads = () => import('@/components/leads/segment/Leads')

const Reports = () => import('@/components/reports/Reports')
const RecommendationReport = () => import('@/components/reports/RecommendationReport')
const AutocastsAndEmailsReport = () => import('@/components/reports/AutocastsAndEmailsReport')
const ByOrdersStatistic = () => import('@/components/reports/ByOrdersStatistic')
const AllOrders = () => import('@/components/reports/orders/AllOrders')
const Order = () => import('@/components/reports/orders/Order')
const EfficiencyLeadhit = () => import('@/components/reports/EfficiencyLeadhit')
const ConsolidatedReport = () => import('@/components/reports/ConsolidatedReport')

const Analytics = () => import('@/components/analytics/Analytics')
const AnalyticsLeads = () => import('@/components/analytics/AnalyticsLeads')
const AnalyticsVisits = () => import('@/components/analytics/AnalyticsVisits')
const AnalyticsEmails = () => import('@/components/analytics/AnalyticsEmails')
const AnalyticsWidgets = () => import('@/components/analytics/AnalyticsWidgets')
const AnalyticsRecommendations = () => import('@/components/analytics/AnalyticsRecommendations')
const AnalyticsEmailsDynamics = () => import('@/components/analytics/AnalyticsEmailsDynamics')
const AnalyticsAutocasts = () => import('@/components/analytics/AnalyticsAutocasts')
const AnalyticsSalesFunnel = () => import('@/components/analytics/AnalyticsSalesFunnel')
const AnalyticsSales = () => import('@/components/analytics/AnalyticsSales')
const AnalyticsOffers = () => import('@/components/analytics/AnalyticsOffers')
const AnalyticsRfm = () => import('@/components/analytics/AnalyticsRfm')
const Offers = () => import('@/components/analytics/Offers')
const AnalyticsKPI = () => import('@/components/analytics/AnalyticsKPI')

const KPI_ARPV = () => import('@/components/analytics/KPI/KPI_ARPV')
const KPI_ARPL = () => import('@/components/analytics/KPI/KPI_ARPL')
const KPI_ARPPU = () => import('@/components/analytics/KPI/KPI_ARPPU')
const KPI_AverageCheck = () => import('@/components/analytics/KPI/KPI_AverageCheck')
const KPI_CAR = () => import('@/components/analytics/KPI/KPI_CAR')
const KPI_PaidOrdersRate = () => import('@/components/analytics/KPI/KPI_PaidOrdersRate')
const KPI_PurchaseRate = () => import('@/components/analytics/KPI/KPI_PurchaseRate')
const KPI_ReturnedCustomers = () => import('@/components/analytics/KPI/KPI_ReturnedCustomers')

const Integration = () => import('@/components/integration/Integration')
const Library = () => import('@/components/library/Library')
const Image = () => import('@/components/library/Image')
const EmailsTemplateList = () => import('@/components/email_template/EmailsTemplateList')
const EmailsTemplate = () => import('@/components/email_template/EmailsTemplate')
const Promocodes = () => import('@/components/library/Promocodes')

const Settings = () => import('@/components/user_settings/Settings')
const AccountSettings = () => import('@/components/user_settings/AccountSettings')
const ChangePassword = () => import('@/components/user_settings/ChangePassword')
const SettingsAlerts = () => import('@/components/user_settings/SettingsAlerts')
const SitesList = () => import('@/components/user_settings/SitesList')
const Users = () => import('@/components/user_settings/Users')
const ToolManagement = () => import('@/components/user_settings/ToolManagement')
const TechnicalAccountSettings = () => import('@/components/user_settings/TechnicalAccountSettings')
const SiteForms = () => import('@/components/user_settings/SiteForms')
const SiteCategories = () => import('@/components/user_settings/SiteCategories')
const TariffsInfo = () => import('@/components/user_settings/TariffsInfo')
const TariffSelection = () => import('@/components/user_settings/TariffSelection')

const Instruments = () => import('@/components/instruments/AllInstruments')
const AutoCastList = () => import('@/components/instruments/emails/AutoCastList')
const MessageCampaignsList = () => import('@/components/instruments/emails/MessageCampaignsList')
const InfoMessageCampaing = () => import('@/components/instruments/emails/InfoMessageCompaing')
const Email = () => import('@/components/instruments/emails/Email')
const CreateMessageCampaign = () => import('@/components/instruments/emails/CreateMessageCampaign')
const EditAutoCast = () => import('@/components/instruments/emails/EditAutoCast')
const InfoAutoCast = () => import('@/components/instruments/emails/InfoAutoCast')
const InfoCaseAutoCast = () => import('@/components/instruments/emails/InfoCaseAutoCast')
const ABTestAutoCast = () => import('@/components/instruments/emails/ABTestAutoCast')

const ListProductRecommendation = () =>
  import('@/components/instruments/recomendation/ListProductRecommendation')
const ListBusinessRules = () => import('@/components/instruments/recomendation/ListBusinessRules')
const AddBusinessRules = () => import('@/components/instruments/recomendation/AddBusinessRules')
const EditRule = () => import('@/components/instruments/recomendation/EditRule')
const EditRecommendation = () => import('@/components/instruments/recomendation/EditRecommendation')

const WidgetList = () => import('@/components/instruments/widgets/WidgetList')
const WidgetEditor = () => import('@/components/instruments/widgets/WidgetEditor')
const widgetsABTests = () => import('@/components/instruments/widgets/widgetsABTests')
const WidgetFrame = () => import('@/components/instruments/widgets/WidgetFrame')

const UserAlertsList = () => import('@/components/instruments/user_alerts/UserAlertsList')
const UserAlertEditor = () => import('@/components/instruments/user_alerts/UserAlertEditor')
const UserAlertHistory = () => import('@/components/instruments/user_alerts/UserAlertHistory')

const ProductSubscriptions = () => import('@/components/instruments/subscriptions/ProductSubscriptions')

const LoyaltyCategories = () => import('@/components/instruments/loyalty/LoyaltyCategories')
const LoyaltyRules = () => import('@/components/instruments/loyalty/LoyaltyRules')

const WebPushCampaignEdit = () => import('@/components/instruments/web_push/WebPushCampaignEdit')
const Pipeline = () => import('@/components/instruments/pipeline/Pipeline')

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/authorization/:key?',
      name: 'authorization',
      component: Authorization,
      meta: {
        layout: 'AuthorizationLayout',
        title: i18n.t('routes.authorization'),
        translate_route: 'routes.authorization',
        requiresAuth: false
      }
    },
    {
      path: '/',
      name: 'Desktop',
      component: Desktop,
      meta: {
        title: i18n.t('routes.desktop'),
        translate_route: 'routes.desktop',
        menu: ['Desktop'],
        requiresAuth: true
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: {
        title: i18n.t('routes.settings'),
        translate_route: 'routes.settings',
        menu: ['settings'],
        requiresAuth: true
      },
      children: [
        {
          path: '/settings/account',
          name: 'settings_account',
          component: AccountSettings,
          meta: {
            title: i18n.t('routes.settings_account'),
            translate_route: 'routes.settings_account',
            menu: ['settings']
          }
        },
        {
          path: '/settings/password',
          name: 'settings_password',
          component: ChangePassword,
          meta: {
            title: i18n.t('routes.change_password'),
            translate_route: 'routes.change_password',
            menu: ['settings']
          }
        },
        {
          path: '/settings/alerts',
          name: 'settings_alerts',
          component: SettingsAlerts,
          meta: {
            title: i18n.t('routes.settings_alerts'),
            translate_route: 'routes.settings_alerts',
            menu: ['settings']
          }
        },
        {
          path: '/settings/sites_list',
          name: 'settings_sites_list',
          component: SitesList,
          meta: {
            title: i18n.t('routes.sites_list'),
            translate_route: 'routes.sites_list',
            menu: ['settings']
          }
        },
        {
          path: '/settings/users',
          name: 'settings_users',
          component: Users,
          meta: {
            title: i18n.t('routes.users'),
            translate_route: 'routes.users',
            menu: ['settings']
          }
        },
        {
          path: '/settings/tool_management',
          name: 'tool_management',
          component: ToolManagement,
          meta: {
            title: i18n.t('routes.tool_management'),
            translate_route: 'routes.tool_management',
            menu: ['settings']
          }
        },
        {
          path: '/settings/technical_account_settings',
          name: 'technical_account_settings',
          component: TechnicalAccountSettings,
          meta: {
            title: i18n.t('settings.technical_account_settings'),
            translate_route: 'settings.technical_account_settings',
            menu: ['settings']
          }
        },
        {
          path: '/settings/site_forms',
          name: 'site_forms',
          component: SiteForms,
          meta: {
            title: i18n.t('routes.site_forms'),
            translate_route: 'routes.site_forms',
            menu: ['settings']
          }
        },
        {
          path: '/settings/site_categories',
          name: 'site_categories',
          component: SiteCategories,
          meta: {
            title: i18n.t('settings.site_categories'),
            translate_route: 'settings.site_categories',
            menu: ['settings']
          }
        },
        {
          path: '/settings/tariffs_info',
          name: 'tariffs_info',
          component: TariffsInfo,
          meta: {
            title: i18n.t('tariffs.information_about_tariffs'),
            translate_route: 'tariffs.information_about_tariffs',
            menu: ['settings']
          }
        },
        {
          path: '/settings/tariff_selection',
          name: 'tariff_selection',
          component: TariffSelection,
          meta: {
            title: i18n.t('tariffs.tariff_selection'),
            translate_route: 'tariffs.tariff_selection',
            menu: ['settings']
          }
        }
      ]
    },
    {
      path: '/leads',
      name: 'leads',
      component: Leads,
      meta: {
        title: i18n.t('routes.leads'),
        translate_route: 'routes.leads',
        menu: ['leads'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/allleads',
      name: 'allleads',
      component: AllLeads,
      meta: {
        title: i18n.t('routes.allleads'),
        translate_route: 'routes.allleads',
        menu: ['leads', 'allleads'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/:lead_id/statistic',
      name: 'lead_statistic',
      component: Lead,
      meta: {
        title: i18n.t('routes.statistic'),
        translate_route: 'routes.statistic',
        menu: ['leads', 'allleads'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/:lead_id/visits',
      name: 'lead_visits',
      component: Lead,
      meta: {
        title: i18n.t('routes.visits'),
        translate_route: 'routes.visits',
        menu: ['leads', 'allleads'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/:lead_id/lead_visits/:visit_id',
      name: 'lead_visit',
      component: Lead,
      meta: {
        title: i18n.t('routes.visit'),
        translate_route: 'routes.visit',
        menu: ['leads', 'allleads'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/:lead_id/timeline',
      name: 'lead_timeline',
      component: Lead,
      meta: {
        title: i18n.t('routes.timeline'),
        translate_route: 'routes.timeline',
        menu: ['leads', 'allleads'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/:lead_id/cart',
      name: 'lead_cart',
      component: Lead,
      meta: {
        title: i18n.t('routes.cart'),
        translate_route: 'routes.cart',
        menu: ['leads', 'allleads'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/:lead_id/letters',
      name: 'lead_letters',
      component: Lead,
      meta: {
        title: i18n.t('routes.letters'),
        translate_route: 'routes.letters',
        menu: ['leads', 'allleads'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/:lead_id/forms',
      name: 'lead_forms',
      component: Lead,
      meta: {
        title: i18n.t('routes.forms'),
        translate_route: 'routes.forms',
        menu: ['leads', 'allleads'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/multilead/:multilead_id/forms',
      name: 'multilead_forms',
      component: Multilead,
      meta: {
        title: i18n.t('routes.forms'),
        translate_route: 'routes.forms',
        menu: ['leads', 'allleads'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/multilead/:multilead_id/leads',
      name: 'multilead_leads',
      component: Multilead,
      meta: {
        title: i18n.t('routes.leads'),
        translate_route: 'routes.leads',
        menu: ['leads', 'allleads'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/multilead/:multilead_id/letters',
      name: 'multilead_letters',
      component: Multilead,
      meta: {
        title: i18n.t('routes.letters'),
        translate_route: 'routes.letters',
        menu: ['leads', 'allleads'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/segments',
      name: 'segments',
      component: AllSegments,
      meta: {
        title: i18n.t('routes.segments'),
        translate_route: 'routes.segments',
        menu: ['leads', 'segments'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/segment/:segment_id',
      name: 'segment_edit',
      component: SegmentEditing,
      meta: {
        title: i18n.t('routes.editing'),
        translate_route: 'routes.editing',
        menu: ['leads', 'segments'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/segment/new',
      name: 'segment_new',
      component: SegmentEditing,
      meta: {
        title: i18n.t('routes.editing'),
        translate_route: 'routes.editing',
        menu: ['leads', 'segments'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/segments/:segment_id/statistic',
      name: 'segment_statistic',
      component: SegmentStatistic,
      meta: {
        title: i18n.t('routes.statistic'),
        translate_route: 'routes.statistic',
        menu: ['leads', 'segments'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/segments/:segment_id/assortment',
      name: 'segment_assortment',
      component: SegmentAssortment,
      meta: {
        title: i18n.t('routes.assortment'),
        translate_route: 'routes.assortment',
        menu: ['leads', 'segments'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/segments/:segment_id/cart',
      name: 'segment_cart',
      component: SegmentCart,
      meta: {
        title: i18n.t('routes.cart'),
        translate_route: 'routes.cart',
        menu: ['leads', 'segments'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/segments/:segment_id/letters',
      name: 'segment_letters',
      component: SegmentLetters,
      meta: {
        title: i18n.t('routes.letters'),
        translate_route: 'routes.letters',
        menu: ['leads', 'segments'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/segments/:segment_id/forms',
      name: 'segment_forms',
      component: SegmentForms,
      meta: {
        title: i18n.t('routes.forms'),
        translate_route: 'routes.forms',
        menu: ['leads', 'segments'],
        requiresAuth: true
      }
    },
    {
      path: '/leads/segments/:segment_id/leads',
      name: 'segment_leads',
      component: SegmentLeads,
      meta: {
        title: i18n.t('routes.leads'),
        translate_route: 'routes.leads',
        menu: ['leads', 'segments'],
        requiresAuth: true
      }
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports,
      meta: {
        title: i18n.t('routes.reports'),
        translate_route: 'routes.reports',
        menu: ['reports'],
        requiresAuth: true
      }
    },
    {
      path: '/reports/recommendation_report',
      name: 'recommendation_report',
      component: RecommendationReport,
      meta: {
        title: i18n.t('routes.reports'),
        translate_route: 'routes.reports',
        menu: ['reports', 'recommendation_report'],
        requiresAuth: true
      }
    },
    {
      path: '/reports/consolidated_report',
      name: 'consolidated_report',
      component: ConsolidatedReport,
      meta: {
        title: i18n.t('routes.reports'),
        translate_route: 'routes.reports',
        menu: ['reports', 'consolidated_report'],
        requiresAuth: true
      }
    },
    {
      path: '/reports/emails_report',
      name: 'emails_report',
      component: AutocastsAndEmailsReport,
      meta: {
        title: i18n.t('routes.reports'),
        translate_route: 'routes.reports',
        menu: ['reports', 'emails_report'],
        requiresAuth: true
      }
    },
    {
      path: '/reports/autocasts_report',
      name: 'autocasts_report',
      component: AutocastsAndEmailsReport,
      meta: {
        title: i18n.t('routes.reports'),
        translate_route: 'routes.reports',
        menu: ['reports', 'autocasts_report'],
        requiresAuth: true
      }
    },
    {
      path: '/reports/by_orders_statistics',
      name: 'by_orders_statistics',
      component: ByOrdersStatistic,
      meta: {
        title: i18n.t('routes.reports'),
        translate_route: 'routes.reports',
        menu: ['reports', 'by_orders', 'by_orders_statistics'],
        requiresAuth: true
      }
    },
    {
      path: '/reports/all_orders',
      name: 'all_orders',
      component: AllOrders,
      meta: {
        title: i18n.t('routes.all_orders'),
        translate_route: 'routes.all_orders',
        menu: ['reports', 'by_orders', 'all_orders'],
        requiresAuth: true
      }
    },
    {
      path: '/reports/all_orders/:order_id',
      name: 'order',
      component: Order,
      meta: {
        title: i18n.t('routes.сustomer_orders'),
        translate_route: 'routes.сustomer_orders',
        menu: ['reports', 'by_orders', 'all_orders'],
        requiresAuth: true
      }
    },
    {
      path: '/reports/efficiency_leadhit',
      name: 'efficiency_leadhit',
      component: EfficiencyLeadhit,
      meta: {
        title: i18n.t('routes.efficiency_leadhit'),
        translate_route: 'routes.efficiency_leadhit',
        menu: ['reports', 'efficiency_leadhit'],
        requiresAuth: true
      }
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: Analytics,
      meta: {
        title: i18n.t('routes.analytics'),
        translate_route: 'routes.analytics',
        menu: ['analytics'],
        requiresAuth: true
      },
      children: [
        {
          path: '/analytics/leads',
          name: 'analytics_leads',
          component: AnalyticsLeads,
          meta: {
            title: i18n.t('routes.analytics_leads'),
            translate_route: 'routes.analytics_leads',
            menu: ['analytics', 'analytics_leads']
          }
        },
        {
          path: '/analytics/visits',
          name: 'analytics_visits',
          component: AnalyticsVisits,
          meta: {
            title: i18n.t('routes.analytics_visits'),
            translate_route: 'routes.analytics_visits',
            menu: ['analytics', 'analytics_visits']
          }
        },
        {
          path: '/analytics/emails',
          name: 'analytics_emails',
          component: AnalyticsEmails,
          meta: {
            title: i18n.t('routes.analytics_emails'),
            translate_route: 'routes.analytics_emails',
            menu: ['analytics', 'analytics_emails']
          }
        },
        {
          path: '/analytics/widgets',
          name: 'analytics_widgets',
          component: AnalyticsWidgets,
          meta: {
            title: i18n.t('routes.analytics_widgets'),
            translate_route: 'routes.analytics_widgets',
            menu: ['analytics', 'analytics_widgets']
          }
        },
        {
          path: '/analytics/recommendations',
          name: 'analytics_recommendations',
          component: AnalyticsRecommendations,
          meta: {
            title: i18n.t('routes.analytics_recommendations'),
            translate_route: 'routes.analytics_recommendations',
            menu: ['analytics', 'analytics_recommendations']
          }
        },
        {
          path: '/analytics/emails_dynamics',
          name: 'analytics_emails_dynamics',
          component: AnalyticsEmailsDynamics,
          meta: {
            title: i18n.t('routes.analytics_emails_dynamics'),
            translate_route: 'routes.analytics_emails_dynamics',
            menu: ['analytics', 'analytics_emails_dynamics']
          }
        },
        {
          path: '/analytics/autocasts',
          name: 'analytics_autocasts',
          component: AnalyticsAutocasts,
          meta: {
            title: i18n.t('routes.analytics_autocasts'),
            translate_route: 'routes.analytics_autocasts',
            menu: ['analytics', 'analytics_autocasts']
          }
        },
        {
          path: '/analytics/sales_funnel',
          name: 'analytics_sales_funnel',
          component: AnalyticsSalesFunnel,
          meta: {
            title: i18n.t('routes.analytics_sales_funnel'),
            translate_route: 'routes.analytics_sales_funnel',
            menu: ['analytics', 'analytics_sales_funnel']
          }
        },
        {
          path: '/analytics/sales',
          name: 'analytics_sales',
          component: AnalyticsSales,
          meta: {
            title: i18n.t('routes.analytics_sales'),
            translate_route: 'routes.analytics_sales',
            menu: ['analytics', 'analytics_sales']
          }
        },
        {
          path: '/analytics/analytic_offers',
          name: 'analytics_offers',
          component: AnalyticsOffers,
          meta: {
            title: i18n.t('routes.analytics_offers'),
            translate_route: 'routes.analytics_offers',
            menu: ['analytics', 'analytics_offers']
          }
        },
        {
          path: '/analytics/rfm',
          name: 'analytics_rfm',
          component: AnalyticsRfm,
          meta: {
            title: i18n.t('routes.analytics_rfm'),
            translate_route: 'routes.analytics_rfm',
            menu: ['analytics', 'analytics_rfm']
          }
        },
        {
          path: '/analytics/offers',
          name: 'offers',
          component: Offers,
          meta: {
            title: i18n.t('routes.offers'),
            translate_route: 'routes.offers',
            menu: ['analytics', 'analytics_offers']
          }
        },
        {
          path: '/analytics/kpi',
          name: 'analytics_kpi',
          component: AnalyticsKPI,
          meta: {
            title: i18n.t('routes.kpi_store'),
            translate_route: 'routes.kpi_store',
            menu: ['analytics', 'analytics_kpi'],
            requiresAuth: true
          },
          children: [
            {
              path: '/analytics/kpi/arpv',
              name: 'analytics_kpi_arpv',
              component: KPI_ARPV,
              meta: {
                title: i18n.t('routes.kpi_store'),
                translate_route: 'routes.kpi_store',
                menu: ['analytics', 'analytics_kpi', 'kpi_arpv']
              }
            },
            {
              path: '/analytics/kpi/arpl',
              name: 'analytics_kpi_arpl',
              component: KPI_ARPL,
              meta: {
                title: i18n.t('routes.kpi_store'),
                translate_route: 'routes.kpi_store',
                menu: ['analytics', 'analytics_kpi', 'kpi_arpl']
              }
            },
            {
              path: '/analytics/kpi/arppu',
              name: 'analytics_kpi_arppu',
              component: KPI_ARPPU,
              meta: {
                title: i18n.t('routes.kpi_store'),
                translate_route: 'routes.kpi_store',
                menu: ['analytics', 'analytics_kpi', 'kpi_arppu']
              }
            },
            {
              path: '/analytics/kpi/average_check',
              name: 'analytics_kpi_average_check',
              component: KPI_AverageCheck,
              meta: {
                title: i18n.t('routes.kpi_store'),
                translate_route: 'routes.kpi_store',
                menu: ['analytics', 'analytics_kpi', 'kpi_average_check']
              }
            },
            {
              path: '/analytics/kpi/car',
              name: 'analytics_kpi_car',
              component: KPI_CAR,
              meta: {
                title: i18n.t('routes.kpi_store'),
                translate_route: 'routes.kpi_store',
                menu: ['analytics', 'analytics_kpi', 'kpi_car']
              }
            },
            {
              path: '/analytics/kpi/paid_offers_rate',
              name: 'analytics_kpi_paid_offers_rate',
              component: KPI_PaidOrdersRate,
              meta: {
                title: i18n.t('routes.kpi_store'),
                translate_route: 'routes.kpi_store',
                menu: ['analytics', 'analytics_kpi', 'kpi_paid_offers_rate']
              }
            },
            {
              path: '/analytics/kpi/purchase_rate',
              name: 'analytics_kpi_purchase_rate',
              component: KPI_PurchaseRate,
              meta: {
                title: i18n.t('routes.kpi_store'),
                translate_route: 'routes.kpi_store',
                menu: ['analytics', 'analytics_kpi', 'kpi_purchase_rate']
              }
            },
            {
              path: '/analytics/kpi/returned_customers',
              name: 'analytics_kpi_returned_customers',
              component: KPI_ReturnedCustomers,
              meta: {
                title: i18n.t('routes.kpi_store'),
                translate_route: 'routes.kpi_store',
                menu: ['analytics', 'analytics_kpi', 'kpi_returned_customers']
              }
            }
          ]
        }
      ]
    },
    {
      path: '/integration',
      name: 'integration',
      component: Integration,
      meta: {
        title: i18n.t('routes.integration'),
        translate_route: 'routes.integration',
        menu: ['integration'],
        requiresAuth: true
      }
    },
    {
      path: '/library',
      name: 'library',
      component: Library,
      meta: {
        title: i18n.t('routes.library'),
        translate_route: 'routes.library',
        menu: ['library'],
        requiresAuth: true
      }
    },
    {
      path: '/library/Image',
      name: 'image',
      component: Image,
      meta: {
        title: i18n.t('routes.image'),
        translate_route: 'routes.image',
        menu: ['library', 'image'],
        requiresAuth: true
      }
    },
    {
      path: '/library/emails_templates',
      name: 'emails_templates',
      component: EmailsTemplateList,
      meta: {
        title: i18n.t('routes.emails_templates'),
        translate_route: 'routes.emails_templates',
        menu: ['library', 'emails_templates'],
        requiresAuth: true
      }
    },
    {
      path: '/library/emails_templates/edit/:template_id',
      name: 'emails_template_edit',
      component: EmailsTemplate,
      meta: {
        title: i18n.t('routes.emails_template'),
        translate_route: 'routes.emails_template',
        menu: ['library', 'emails_templates'],
        requiresAuth: true
      }
    },
    {
      path: '/library/emails_templates/new',
      name: 'emails_template_new',
      component: EmailsTemplate,
      meta: {
        title: i18n.t('routes.emails_template'),
        translate_route: 'routes.emails_template',
        menu: ['library', 'emails_templates'],
        requiresAuth: true
      }
    },
    {
      path: '/library/emails_templates/new_webpush',
      name: 'webpush_template_new',
      component: WebPushCampaignEdit,
      meta: {
        title: i18n.t('routes.emails_template'),
        translate_route: 'routes.emails_template',
        menu: ['library', 'emails_templates'],
        requiresAuth: true
      }
    },
    {
      path: '/library/emails_templates/edit_webpush/:template_id',
      name: 'webpush_template_edit',
      component: WebPushCampaignEdit,
      meta: {
        title: i18n.t('routes.emails_template'),
        translate_route: 'routes.emails_template',
        menu: ['library', 'emails_templates'],
        requiresAuth: true
      }
    },
    {
      path: '/library/promocodes',
      name: 'promocodes',
      component: Promocodes,
      meta: {
        title: i18n.t('routes.promotional_codes'),
        translate_route: 'routes.promotional_codes',
        menu: ['library', 'promocodes'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments',
      name: 'instruments',
      component: Instruments,
      meta: {
        title: i18n.t('routes.instruments'),
        translate_route: 'routes.instruments',
        menu: ['instruments'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/autocast_list',
      name: 'autocast_list',
      component: AutoCastList,
      meta: {
        title: i18n.t('routes.autocast'),
        translate_route: 'routes.autocast',
        menu: ['instruments', 'autocast_list'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/autocast_list/info_autocast/:email_id?',
      name: 'info_autocast',
      component: InfoAutoCast,
      meta: {
        title: i18n.t('instruments.information_about_autocast'),
        translate_route: 'instruments.information_about_autocast',
        menu: ['instruments', 'autocast_list'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/autocast_list/info_autocast/:email_id?/cases::message_id',
      name: 'info_autocast_cases',
      component: InfoCaseAutoCast,
      meta: {
        title: i18n.t('instruments.information_about_autocast'),
        translate_route: 'instruments.information_about_autocast',
        menu: ['instruments', 'autocast_list'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/autocast_list/edit_autocast/:email_id?',
      name: 'edit_autocast',
      component: EditAutoCast,
      meta: {
        title: i18n.t('routes.editing_autocast'),
        translate_route: 'routes.editing_autocast',
        menu: ['instruments', 'autocast_list', 'edit_autocast'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/autocast_list/create_autocast/new',
      name: 'create_autocast',
      component: EditAutoCast,
      meta: {
        title: i18n.t('routes.create_autocast'),
        translate_route: 'routes.create_autocast',
        menu: ['instruments', 'autocast_list', 'edit_autocast'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/autocast_list/edit_autocast/:email_id?/ab_test',
      name: 'ab_test',
      component: ABTestAutoCast,
      meta: {
        title: i18n.t('instruments.ab_test.ab_testing'),
        translate_route: 'instruments.ab_test.ab_testing',
        menu: ['instruments', 'autocast_list', 'edit_autocast', 'ab_test'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/message_campaigns_list',
      name: 'message_campaigns_list',
      component: MessageCampaignsList,
      meta: {
        title: i18n.t('routes.emails'),
        translate_route: 'routes.emails',
        menu: ['instruments', 'message_campaigns_list'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/message_campaigns_list/info_message_campaing/:email_id?',
      name: 'info_message_campaing',
      component: InfoMessageCampaing,
      meta: {
        title: i18n.t('instruments.information_about_emails'),
        translate_route: 'instruments.information_about_emails',
        menu: ['instruments', 'message_campaigns_list', 'info_message_campaing'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/message_campaigns_list/create_email',
      name: 'create_email',
      component: CreateMessageCampaign,
      meta: {
        title: i18n.t('routes.create_email'),
        translate_route: 'routes.create_email',
        menu: ['instruments', 'message_campaigns_list', 'create_email'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/emails/:email_id',
      name: 'email',
      component: Email,
      meta: {
        title: i18n.t('routes.emails'),
        translate_route: 'routes.emails',
        menu: ['instruments', 'emails', 'email'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/list_product_recommendation',
      name: 'ListProductRecommendation',
      component: ListProductRecommendation,
      meta: {
        title: i18n.t('routes.recommendations'),
        translate_route: 'routes.recommendations',
        menu: ['instruments', 'ListProductRecommendation', 'recommendation'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/list_product_recommendation/edit_recommendation/:service_name',
      name: 'EditRecommendation',
      component: EditRecommendation,
      props: true,
      meta: {
        title: i18n.t('instruments.recommendation.edit_recommendation'),
        translate_route: 'instruments.recommendation.edit_recommendation',
        menu: ['instruments', 'ListProductRecommendation', 'EditRecommendation', 'recommendation'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/list_product_recommendation/create_recommendation',
      name: 'CreateRecommendation',
      component: EditRecommendation,
      meta: {
        title: i18n.t('instruments.recommendation.edit_recommendation'),
        translate_route: 'instruments.recommendation.edit_recommendation',
        menu: ['instruments', 'ListProductRecommendation', 'EditRecommendation', 'recommendation'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/list_business_rules',
      name: 'ListBusinessRules',
      component: ListBusinessRules,
      meta: {
        title: i18n.t('routes.bisness_rules'),
        translate_route: 'routes.bisness_rules',
        menu: ['instruments', 'ListBusinessRules', 'recommendation'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/add_business_rules',
      name: 'AddBusinessRules',
      component: AddBusinessRules,
      meta: {
        title: i18n.t('routes.new_business_rules'),
        translate_route: 'routes.new_business_rules',
        menu: ['instruments', 'ListBusinessRules', 'AddBusinessRules', 'recommendation'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/list_business_rules/edit_rule/:id',
      name: 'EditRule',
      component: EditRule,
      meta: {
        title: i18n.t('instruments.business_rules.edit_business_rule'),
        translate_route: 'instruments.business_rules.edit_business_rule',
        menu: [
          'instruments',
          'ListBusinessRules',
          'AddBusinessRules',
          'EditRule',
          'recommendation'
        ],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/list_business_rules/create_rule/',
      name: 'CreateRule',
      component: EditRule,
      props: true,
      meta: {
        title: i18n.t('routes.new_business_rules'),
        translate_route: 'routes.new_business_rules',
        menu: [
          'instruments',
          'ListBusinessRules',
          'AddBusinessRules',
          'EditRule',
          'recommendation'
        ],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/widget_list/',
      name: 'widget_list',
      component: WidgetList,
      meta: {
        title: i18n.t('routes.widgets'),
        translate_route: 'routes.widgets',
        menu: ['instruments', 'widgets', 'widget_list'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/widget/:id',
      name: 'widget_editor',
      component: WidgetEditor,
      meta: {
        title: i18n.t('routes.widgets'),
        translate_route: 'routes.widgets',
        menu: ['instruments', 'widgets'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/widget',
      name: 'new_widget',
      component: WidgetEditor,
      meta: {
        title: i18n.t('routes.widgets'),
        translate_route: 'routes.widgets',
        menu: ['instruments', 'widgets'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/widget_list/abtests',
      name: 'widgets_abtests',
      component: widgetsABTests,
      meta: {
        title: i18n.t('routes.widgets'),
        translate_route: 'routes.widgets',
        menu: ['instruments', 'widgets'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/widget_list/:id/frame',
      name: 'widget_frame',
      component: WidgetFrame,
      meta: {
        layout: 'WidgetLayout',
        title: i18n.t('routes.widgets'),
        translate_route: 'routes.widgets',
        menu: ['instruments', 'widgets'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/user_alerts/',
      name: 'user_alerts_list',
      component: UserAlertsList,
      meta: {
        title: i18n.t('instruments.alerts.user_alerts'),
        translate_route: 'instruments.alerts.user_alerts',
        menu: ['instruments', 'user_alerts'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/user_alerts/:id',
      name: 'user_alert_editor',
      component: UserAlertEditor,
      meta: {
        title: i18n.t('instruments.alerts.user_alerts'),
        translate_route: 'instruments.alerts.user_alerts',
        menu: ['instruments', 'user_alerts'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/user_alerts/new',
      name: 'user_alert_new',
      component: UserAlertEditor,
      meta: {
        title: i18n.t('instruments.alerts.user_alerts'),
        translate_route: 'instruments.alerts.user_alerts',
        menu: ['instruments', 'user_alerts'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/user_alerts/:id/history',
      name: 'user_alert_history',
      component: UserAlertHistory,
      meta: {
        title: i18n.t('instruments.alerts.user_alerts'),
        translate_route: 'instruments.alerts.user_alerts',
        menu: ['instruments', 'user_alerts'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/product_subscriptions',
      name: 'product_subscriptions',
      component: ProductSubscriptions,
      meta: {
        title: i18n.t('instruments.subscriptions.product_subscriptions'),
        translate_route: 'instruments.subscriptions.product_subscriptions',
        menu: ['instruments', 'product_subscriptions'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/loyalty_categories',
      name: 'loyalty_categories',
      component: LoyaltyCategories,
      meta: {
        title: i18n.t('instruments.loyalty.loyalty_categories'),
        translate_route: 'instruments.loyalty.loyalty_categories',
        menu: ['instruments', 'loyalty', 'loyalty_categories'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/loyalty_rules',
      name: 'loyalty_rules',
      component: LoyaltyRules,
      meta: {
        title: i18n.t('instruments.loyalty.loyalty_rules'),
        translate_route: 'instruments.loyalty.loyalty_rules',
        menu: ['instruments', 'loyalty', 'loyalty_rules'],
        requiresAuth: true
      }
    },
    {
      path: '/instruments/pipeline',
      name: 'pipeline',
      component: Pipeline,
      meta: {
        title: i18n.t('routes.pipeline'),
        translate_route: 'routes.pipeline',
        menu: ['instruments', 'pipeline'],
        requiresAuth: true
      }
    },
    {
      path: '*',
      redirect: { name: 'Desktop' }
    }
  ],
  logOut: function () {
    deleteLocalStorageData()
    location.reload()
  }
})

router.beforeEach((to, from, next) => {
  const isAuth = !!localStorage.getItem('lh-cp-auth-token')

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuth) {
      const params = to.params ? to.params : {}
      next({ name: 'authorization', params: params })
    } else if (isAuth && store.getters.userDoesNotHaveSites && to.name !== 'settings_sites_list') {
      next({ name: 'settings_sites_list' })
    } else if (!isAuth && !to.name) {
      const params = to.params ? to.params : {}
      next({ name: 'authorization', params: params })
    } else if (
      to.name === 'pipeline' &&
      store.getters.getSiteId &&
      store.getters.getSiteId !== PIPELINE_TEST_SITE_ID
    ) {
      next({ name: 'instruments' })
    } else if (
      to.name === 'analytics_rfm' &&
      store.getters.getSiteId &&
      !isRfmAvailable(store.getters.getSiteId)
    ) {
      next({ name: 'analytics' })
    } else {
      next()
    }
  } else {
    if (isAuth && to.name === 'authorization') {
      if (to.params.key) {
        deleteLocalStorageData()
        const site_id = to.query.site_id || null
        if (site_id) {
          router.replace({
            name: 'authorization',
            params: { key: to.params.key },
            query: { site_id }
          })
        } else {
          router.replace({ name: 'authorization', params: { key: to.params.key } })
        }
        router.go()
      } else {
        next({ name: 'Desktop' })
      }
    } else if (isAuth && !to.name) {
      next({ name: 'Desktop' })
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js